import { TimeStamped } from '../django';
import { applyTimezone, parseDate } from '../helpers/date';
import { parseNumeric } from '../helpers/number';

export class LenderPortfolio implements TimeStamped {
  id: string;
  created: Date;
  modified: Date;
  fullName: string;
  shortName: string;
  identity: string;
  walletId: string;
  startDate: Date;
  endDate: Date;
  balance: number;

  constructor(data: string | LenderPortfolio | DjangoLenderPortfolio = {}) {
    if (typeof data === 'string') {
      bindConstructorDataToInstance(this, { id: data });
    } else {
      bindConstructorDataToInstance(this, data);
    }
  }
}

export function parseLenderPortfolio(data?: string | LenderPortfolio | DjangoLenderPortfolio) {
  if (data) {
    return new LenderPortfolio(data);
  } else {
    return undefined;
  }
}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoLenderPortfolio {
  id?: string;
  created?: string;
  modified?: string;
  full_name?: string;
  short_name?: string;
  identity?: string;
  wallet_id?: string;
  start_date?: string;
  end_date?: string;
  balance?: number;
}

///////////////
/// PRIVATE ///
///////////////
function bindConstructorDataToInstance(
  instance: LenderPortfolio,
  data: LenderPortfolio | DjangoLenderPortfolio,
) {
  const jsData = bindDjangoPropsToJs(data);
  instance.id = jsData.id;
  instance.created = parseDate(jsData.created);
  instance.modified = parseDate(jsData.modified);
  instance.balance = parseNumeric(jsData.balance);
  instance.fullName = jsData.fullName;
  instance.shortName = jsData.shortName;
  instance.identity = jsData.identity;
  instance.walletId = jsData.walletId;
  instance.startDate = applyTimezone(parseDate(jsData.startDate), 0);
  instance.endDate = applyTimezone(parseDate(jsData.endDate), 0);
}

function bindDjangoPropsToJs(data: LenderPortfolio | DjangoLenderPortfolio) {
  const djangoData = data as DjangoLenderPortfolio;
  const jsData = data as LenderPortfolio;
  return {
    ...data,
    fullName: djangoData.full_name || jsData.fullName,
    shortName: djangoData.short_name || jsData.shortName,
    walletId: djangoData.wallet_id || jsData.walletId,
    startDate: djangoData.start_date || jsData.startDate,
    endDate: djangoData.end_date || jsData.endDate,
  } as LenderPortfolio;
}
